import { twMerge } from 'tailwind-merge';
import { IconInfoCircle } from '@tabler/icons-react';

interface TextInfoProps {
  text: string;
  icon?: React.ReactNode;
  containerClassName?: string;
  textClassName?: string;
  defaultIconClassName?: string;
}

export const TextInfo = ({
  text,
  icon,
  containerClassName,
  textClassName,
  defaultIconClassName,
}: TextInfoProps) => {
  return (
    <div className={twMerge('flex gap-2', containerClassName)}>
      {icon || (
        <IconInfoCircle
          stroke={2}
          className={twMerge(
            '-mt-[1.75px] text-indigo-600 w-5.5 min-w-5.5 h-5.5 min-h-5.5',
            defaultIconClassName,
          )}
        />
      )}
      <p className={twMerge('text-indigo-600 text-sm', textClassName)}>
        {text}
      </p>
    </div>
  );
};
